<template>
  <div
    class="product-description pb-4"
    v-if="
      tabs.length > 0 ||
        (isAuthenticated && product.productInfos.RATE_ENABLED == 'true')
    "
  >
    <div v-if="$vuetify.breakpoint.smAndUp">
      <v-tabs
        v-model="selectedTab"
        slider-size="0"
        :show-arrows="$vuetify.breakpoint.xs"
      >
        <v-tab
          v-for="(tab, idx) in tabs"
          :key="idx"
          class="text-body-2 text-uppercase font-weight-bold"
        >
          {{ tab.title }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="selectedTab">
        <v-tab-item v-for="tab in tabs" :key="tab.title" :class="tab.cssClass">
          <div
            v-for="item in tab.items"
            :key="item.title"
            :class="item.cssClass"
          >
            <div
              class="text-body-2 font-weight-bold mb-1 mt-3"
              v-if="item.title"
            >
              {{ item.title }}
            </div>
            <div
              class="text-body-2 content default--text"
              v-for="path in item.paths"
              :key="path.key"
            >
              <component
                :is="path.template || 'DefaultTpl'"
                :content="path.content"
                :append="path.append"
                class="component pb-4"
              />
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-expansion-panels
      v-else
      v-model="productDescriptionAccordion"
      accordion
      flat
      tile
      :focusable="selectedTab"
    >
      <!-- first panel: product description -->
      <v-expansion-panel
        v-for="tab in tabs"
        :key="tab.key"
        :class="tab.cssClass"
      >
        <v-expansion-panel-header
          hide-actions
          class="pa-3 px-sm-3 primary--text font-weight-bold"
        >
          <template v-slot:default="{ open }">
            <span class="font-weight-bold w-100" v-html="tab.title"></span>
            <v-icon color="primary" medium>
              <template v-if="open">$expandLess</template>
              <template v-else>$next</template>
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mt-2">
          <div
            v-for="item in tab.items"
            :key="item.title"
            class="pb-4"
            :class="item.cssClass"
          >
            <h4
              v-if="item.title"
              class="mb-1 description-header text-uppercase font-weight-bold"
            >
              {{ item.title }}
            </h4>
            <div
              v-for="path in item.paths"
              :key="path.key"
              class="description-content"
              @click="clicked"
            >
              <component
                :is="path.template || 'DefaultTpl'"
                :content="path.content"
                :append="path.append"
              />
            </div>
          </div>
        </v-expansion-panel-content>
        <v-divider></v-divider>
      </v-expansion-panel>

      <!-- second panel and over -> product rating -->
      <v-expansion-panel
        v-if="isAuthenticated && product.productInfos.RATE_ENABLED == 'true'"
      >
        <v-expansion-panel-header
          hide-actions
          class="pa-3 px-sm-3 primary--text font-weight-bold"
        >
          <template v-slot:default="{ open }">
            <span class="font-weight-bold w-100">Recensione clienti</span>
            <v-icon color="primary" medium>
              <template v-if="open">$expandLess</template>
              <template v-else>$next</template>
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="mt-2">
          <ProductCustomerVotes
            class="my-3"
            :productId="product.productId"
            :key="product.productId"
          />
        </v-expansion-panel-content>
        <v-divider></v-divider>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import clickHandler from "~/mixins/clickHandler";

import ProductRating from "@/components/product/ProductRating.vue";
import ProductCustomerVotes from "@/components/product/ProductCustomerVotes.vue";
import DefaultTpl from "./templates/DefaultTpl.vue";
import tabsConfig from "/public/product/descriptionTabsConfig.json";

import { mapGetters } from "vuex";
import get from "lodash/get";
import kebabCase from "lodash/kebabCase";

export default {
  name: "ProductDescription",
  /* eslint-disable vue/no-unused-components */
  components: {
    ProductRating,
    ProductCustomerVotes,
    DefaultTpl
  },
  mixins: [clickHandler],

  data() {
    return {
      // panelOpen: 0,
      selectedTab: null,
      productDescriptionTabs: tabsConfig
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    productMetadata: {
      type: Object
    },
    panelOpen: {
      type: [Number, String]
    }
  },
  created() {
    if (
      this.product.productId == 148000015 ||
      this.product.productId == 148000017
    ) {
      this.product.metaData.product_description = {
        sale_description:
          "Standard drive shaft with connection forks<br><br><strong>Product advantages</strong><br><br>The W series PTO drive shaft offers tried-and-tested Walterscheid technology and is perfectly designed to suit all application areas. The excellent benefits of this Walterscheid PTO drive shaft is a long service life, ease of use, and great safety properties. For decades, Walterscheid has been a guarantee of the highest quality. The W series are optimally dimensioned for drivetrain tasks, from simple to complex ones. It impresses users with its robust design and high reliability for daily use. Another advantage: All of the components in the PTO drive shaft W series can be replaced really easily to increase ease of use or if spare parts are needed.",
        certifications: "",
        scope:
          'The scope of delivery includes a complete drive shaft size W2400 with connection forks (profile 1 3/8" (6)), guard, retaining chain(s), operating and assembly instructions incl. declaration of conformity.',
        instructions:
          "The standard design is suitable for the use of drive shafts with parallel axes. Depending on the application, it is recommended that a simple joint can be operated up to an angle of max. 25°. A constant angle during continuous operation of max. 15° should not be exceeded.",
        legal_notes:
          "All components are designed specifically for the device and performance and it is not allowed to exchange for components other than those prescribed by Walterscheid. Damaged or missing parts can only replace with original Walterscheid parts and retrofit them in accordance with regulations and after consultation with Walterscheid.\nThe assignment, assembly and use of this model requires a detailed preliminary examination by qualified personnel. It is imperative to check the existing facilities and all of the machinery and equipment for their suitability for attachment. In particular, the characteristic values (e.g. vertical and pulling loads or torques) and the geometries (e.g. dimensions, screw hole patterns, free spaces) must be observed. Depending on the existing equipment of the machine, this can result in the use or purchase of additional components. The content of operating instructions must be observed.",
        operating_instructions: "",
        specification:
          '<dl class="attributes dl-horizontal"><dt id="attrTitle_1" class="hasTooltip" title="" data-placement="right" data-original-title="Type">Type</dt><dd id="attrValue_1">W</dd><dt id="attrTitle_2" class="hasTooltip" title="" data-placement="right" data-original-title="Size">Size</dt><dd id="attrValue_2">2400</dd><dt id="attrTitle_3" class="hasTooltip" title="" data-placement="right" data-original-title="Shaft length (Lz)">Shaft length (Lz)</dt><dd id="attrValue_3">1010</dd><dt id="attrTitle_4" class="hasTooltip" title="" data-placement="right" data-original-title="Item no. attachment WH-A">Item no. attachment WH-A</dt><dd id="attrValue_4">133836</dd><dt id="attrTitle_5" class="hasTooltip" title="" data-placement="right" data-original-title="Item no. attachment WH-I">Item no. attachment WH-I</dt><dd id="attrValue_5">133836</dd><dt id="attrTitle_6" class="hasTooltip" title="" data-placement="right" data-original-title="Torque of clutch in daNm">Torque of clutch in daNm</dt><dd id="attrValue_6">0</dd><dt id="attrTitle_7" class="hasTooltip" title="" data-placement="right" data-original-title="Rotation speed max. RPM">Rotation speed max. RPM</dt><dd id="attrValue_7">1000 UPM</dd><dt id="attrTitle_8" class="hasTooltip" title="" data-placement="right" data-original-title="Form attachment WH-A">Form attachment WH-A</dt><dd id="attrValue_8">KP1 3/8</dd><dt id="attrTitle_9" class="hasTooltip" title="" data-placement="right" data-original-title="Form attachment WH-I">Form attachment WH-I</dt><dd id="attrValue_9">KP1 3/8</dd><dt id="attrTitle_10" class="hasTooltip" title="" data-placement="right" data-original-title="Cone Type WH-A">Cone Type WH-A</dt><dd id="attrValue_10">RP6</dd><dt id="attrTitle_11" class="hasTooltip" title="" data-placement="right" data-original-title="Length of guard tube (outer)">Length of guard tube (outer)</dt><dd id="attrValue_11">795</dd><dt id="attrTitle_12" class="hasTooltip" title="" data-placement="right" data-original-title="Length of guard tube (inner)">Length of guard tube (inner)</dt><dd id="attrValue_12">790</dd><dt id="attrTitle_13" class="hasTooltip" title="" data-placement="right" data-original-title="Inner profile length">Inner profile length</dt><dd id="attrValue_13">885</dd><dt id="attrTitle_14" class="hasTooltip" title="" data-placement="right" data-original-title="Attachment type of profile">Attachment type of profile</dt><dd id="attrValue_14">AA</dd><dt id="attrTitle_15" class="hasTooltip" title="" data-placement="right" data-original-title="Cone type WH-I">Cone type WH-I</dt><dd id="attrValue_15">RP6</dd><dt id="attrTitle_16" class="hasTooltip" title="" data-placement="right" data-original-title="Nipple form / position I/A">Nipple form / position I/A</dt><dd id="attrValue_16">LB LB</dd><dt id="attrTitle_17" class="hasTooltip" title="" data-placement="right" data-original-title="Protective colour">Protective colour</dt><dd id="attrValue_17">Yellow</dd><dt id="attrTitle_18" class="hasTooltip" title="" data-placement="right" data-original-title="SNR cone WH-A">SNR cone WH-A</dt><dd id="attrValue_18">199175</dd><dt id="attrTitle_19" class="hasTooltip" title="" data-placement="right" data-original-title="Outer profile length">Outer profile length</dt><dd id="attrValue_19">865</dd><dt id="attrTitle_20" class="hasTooltip" title="" data-placement="right" data-original-title="Chain WH-A">Chain WH-A</dt><dd id="attrValue_20">K</dd><dt id="attrTitle_21" class="hasTooltip" title="" data-placement="right" data-original-title="SNR cone WH-I">SNR cone WH-I</dt><dd id="attrValue_21">199175</dd><dt id="attrTitle_22" class="hasTooltip" title="" data-placement="right" data-original-title="Cross seal">Cross seal</dt><dd id="attrValue_22">STANDARD</dd><dt id="attrTitle_23" class="hasTooltip" title="" data-placement="right" data-original-title="Abbreviation attachment WH-A">Abbreviation attachment WH-A</dt><dd id="attrValue_23">ASGE</dd><dt id="attrTitle_24" class="hasTooltip" title="" data-placement="right" data-original-title="Abbreviation attachment WH-I">Abbreviation attachment WH-I</dt><dd id="attrValue_24">ASGE</dd><dt id="attrTitle_25" class="hasTooltip" title="" data-placement="right" data-original-title="Profile tube - outer type">Profile tube - outer type</dt><dd id="attrValue_25">S5</dd><dt id="attrTitle_26" class="hasTooltip" title="" data-placement="right" data-original-title="Profile tube - inner type">Profile tube - inner type</dt><dd id="attrValue_26">S4LH</dd><dt id="attrTitle_27" class="hasTooltip" title="" data-placement="right" data-original-title="Guard type">Guard type</dt><dd id="attrValue_27">ST25Z</dd></dl>'
      };
    }
    if (
      this.product.productId == 148000016 ||
      this.product.productId == 148000018
    ) {
      this.product.metaData.product_description = {
        sale_description:
          "The listing of this OEM article is for the purpose of identification only. It is not intended as a spare part until further notice!",
        certifications: "",
        legal_notes:
          "All components are designed specifically for the device and performance and it is not allowed to exchange for components other than those prescribed by Walterscheid. Damaged or missing parts can only replace with original Walterscheid parts and retrofit them in accordance with regulations and after consultation with Walterscheid. The assignment, assembly and use of this model requires a detailed preliminary examination by qualified personnel. It is imperative to check the existing facilities and all of the machinery and equipment for their suitability for attachment. In particular, the characteristic values (e.g. vertical and pulling loads or torques) and the geometries (e.g. dimensions, screw hole patterns, free spaces) must be observed. Depending on the existing equipment of the machine, this can result in the use or purchase of additional components. The content of operating instructions must be observed.",
        operating_instructions: "",
        specification:
          '<dl class="attributes dl-horizontal"><dt id="attrTitle_1" class="hasTooltip" title="" data-placement="right" data-original-title="Size">Size</dt><dd id="attrValue_1">2200</dd><dt id="attrTitle_2" class="hasTooltip" title="" data-placement="right" data-original-title="Type">Type</dt><dd id="attrValue_2">K33L</dd><dt id="attrTitle_3" class="hasTooltip" title="" data-placement="right" data-original-title="Torque of clutch in daNm">Torque of clutch in daNm</dt><dd id="attrValue_3">80</dd><dt id="attrTitle_4" class="hasTooltip" title="" data-placement="right" data-original-title="Nipple shape/position">Nipple shape/position</dt><dd id="attrValue_4">NIPPEL-1</dd><dt id="attrTitle_5" class="hasTooltip" title="" data-placement="right" data-original-title="SNR.-Gehäuse/E-Kuppl">SNR.-Gehäuse/E-Kuppl</dt><dd id="attrValue_5">604983</dd><dt id="attrTitle_6" class="hasTooltip" title="" data-placement="right" data-original-title="Pitch circle diameter">Pitch circle diameter</dt><dd id="attrValue_6">0</dd><dt id="attrTitle_7" class="hasTooltip" title="" data-placement="right" data-original-title="SNR.-Housing/E-Coupl">SNR.-Housing/E-Coupl</dt><dd id="attrValue_7">51493</dd><dt id="attrTitle_8" class="hasTooltip" title="" data-placement="right" data-original-title="Bearing">Bearing</dt><dd id="attrValue_8">STANDARD</dd><dt id="attrTitle_9" class="hasTooltip" title="" data-placement="right" data-original-title="Number of inner springs">Number of inner springs</dt><dd id="attrValue_9">19</dd><dt id="attrTitle_10" class="hasTooltip" title="" data-placement="right" data-original-title="Surface/Paint">Surface/Paint</dt><dd id="attrValue_10">LACK.Yellow</dd><dt id="attrTitle_11" class="hasTooltip" title="" data-placement="right" data-original-title="Connection profile hub">Connection profile hub</dt><dd id="attrValue_11">KNP1 3/8-6</dd><dt id="attrTitle_12" class="hasTooltip" title="" data-placement="right" data-original-title="Torque tolerance class and dimension in %">Torque tolerance class and dimension in %</dt><dd id="attrValue_12">STANDARD</dd><dt id="attrTitle_13" class="hasTooltip" title="" data-placement="right" data-original-title="Total length">Total length</dt><dd id="attrValue_13">145</dd><dt id="attrTitle_14" class="hasTooltip" title="" data-placement="right" data-original-title="Distance from drilling end">Distance from drilling end</dt>'
      };
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    }),
    tabs() {
      let tabs = [];
      this.productDescriptionTabs.forEach(tabMeta => {
        let items = [];
        tabMeta.items.forEach(parMeta => {
          let paths = [];
          parMeta.paths.forEach(pathMeta => {
            let content = get(this.product, pathMeta.data || pathMeta);
            let append = pathMeta.append;
            // check if content is empty
            if (content && content !== "<p></p>") {
              // check if table has empty cells
              if (pathMeta.template === "TableTpl") {
                let cells = JSON.parse(content).cells;
                console.log(cells);
                let hasContent = cells.find(c => {
                  return c !== null;
                });
                if (!hasContent) {
                  return;
                }
              }
              if (pathMeta.template === "ValueTpl") {
                let value = JSON.parse(content).value;
                if (!value) {
                  return;
                }
              }
              paths.push({
                key: pathMeta.data || pathMeta,
                content: content,
                template: pathMeta.template,
                append: append
              });
            }
          });
          if (paths.length > 0) {
            items.push({
              title: parMeta.title,
              paths: paths,
              cssClass: get(parMeta, "cssClass", kebabCase(parMeta.title))
            });
          }
        });
        if (items.length > 0) {
          tabs.push({
            title: tabMeta.title,
            items: items,
            cssClass: get(tabMeta, "cssClass", kebabCase(tabMeta.title))
          });
        }
      });

      return tabs;
    },
    productDescriptionAccordion: {
      get() {
        return this.panelOpen;
      },
      set(value) {
        this.$emit("update:panelOpen", value);
      }
    }
  }
};
</script>

<style lang="scss">
.product-description {
  table {
    border-collapse: collapse;
  }
  table,
  tr,
  td,
  th {
    border: 1px solid var(--v-grey-base);
  }
  td,
  th {
    padding: 2px 6px;
  }
  th {
    background-color: var(--v-grey-lighten1);
  }

  .v-expansion-panels {
    .v-expansion-panel-header {
      font-size: 22px;
    }
  }

  .v-expansion-panel-content {
    color: $text-color;
  }

  @media #{map-get($display-breakpoints, 'xs-only')} {
    .v-expansion-panels {
      .v-expansion-panel-header {
        font-size: 16px;
      }
      .v-expansion-panel-content {
        .v-expansion-panel-content__wrap {
          .description-header {
            font-size: 16px;
          }
          .description-content {
            font-size: 14px;
          }
        }
      }
      // .v-expansion-panel {
      //   border-bottom: 1px solid var(--v-grey-lighten1);
      // }
    }
  }
  .producer_info .text-h5 {
    font-weight: bold;
  }
  .v-slide-group__wrapper {
    position: relative;
    top: 2px;
    .v-slide-group__content {
      width: fit-content;
    }
  }
  .v-tabs {
    border-bottom: none;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      .v-slide-group__prev,
      .v-slide-group__next {
        display: none !important;
      }
      .v-tabs-bar__content {
        width: auto;
      }
    }
  }
  .v-tabs-bar {
    height: 57px;
    width: 100%;
    background-color: var(--v-grey-lighten2);
  }
  .v-tabs-items {
    background: white !important;
    border: 1px solid $secondary;
    padding: 10px;
    border-radius: 0 0 8px 8px;
    border-top: none;
  }
  .v-tab {
    background-color: $secondary;
    color: white;
    font-weight: bold;
    letter-spacing: 0px;
    border: 1px solid $secondary;
    // border-bottom: 2px solid var(--v-secondary-base) !important;
    //color: var(--v-secondary-base) !important;
    border-radius: 4px 4px 0 0;
    margin-right: 12px;
    text-transform: none;
    @media #{map-get($display-breakpoints, 'xs-only')} {
      font-size: 14px;
      padding: 0px 5px;
    }
    &:hover {
      color: $primary;
      background-color: white;
    }
  }
  .v-tab--active {
    font-weight: bold;
    border-bottom: 2px solid transparent !important;
  }
}
</style>
